import { useRouter } from 'expo-router'
import { FormattedMessage } from 'react-intl'

import type { TMediumCommunityApi } from '@/src/features/community/api/communityApi.types'
import { useRandomPopularUnprayedIntentionsQuery } from '@/src/features/intention/services/useRandomPopularUnprayedIntentionsQuery'
import type { TSourceParam } from '@/src/general/constants/routes'
import { useTrackDisplayed } from '@/src/general/hooks/useTrackOnce'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

export const usePublicationRandomIntention = ({
  community,
  publicationId,
  source,
}: TSourceParam & {
  community: TMediumCommunityApi
  publicationId: number
}) => {
  const { routes } = useRoutes()
  const { push } = useRouter()

  const { intention, isLoading } = useRandomPopularUnprayedIntentionsQuery(community.id, publicationId)

  useTrackDisplayed(EVENTS.POST_PRAY_PUBLICATION_PRAY_INTENTION_DISPLAYED, intention && publicationId, {
    trackingSource: source,
  })

  const onPray = () => {
    GTM.sendEvent(EVENTS.POST_PRAY_PUBLICATION_PRAY_INTENTION_CLICKED, { trackingSource: source })
    push(
      routes.publicationByIdRewardPray(
        publicationId.toString(),
        intention?.id?.toString() || '',
        intention?.shareToken || '',
      ),
    )
  }

  const title = {
    default: (
      <FormattedMessage
        id="pray.intention.publication.show"
        values={{
          user: intention?.user?.name,
          community: community.name,
        }}
      />
    ),
    prayed: (
      <FormattedMessage
        id="pray.intention.publication.done"
        values={{
          user: intention?.user?.name,
        }}
      />
    ),
  }

  return {
    isLoading,
    title,
    intention,
    onPray,
  }
}
